import { render, staticRenderFns } from "./SampleValidationVibration.vue?vue&type=template&id=0dc90bfb&scoped=true"
import script from "./SampleValidationVibration.vue?vue&type=script&lang=js"
export * from "./SampleValidationVibration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc90bfb",
  null
  
)

export default component.exports